import React from "react";
import styled from "styled-components";
import BackArrowIcon from "../Icons/BackArrowIcon";
import BlankAvatar from "../Icons/BlankAvatar";

interface ChatMenuPersonListProps {
  onBack: () => void;
  title: string;
  people: Array<{ name: string; timestamp: string; role:'player' | 'staff' | 'parent' | 'guest'; }>;
}

const StyledChatMenuPersonList = styled.div.attrs({ className: "ChatMenuPersonList" })`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 250px;

  .top-bar {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-bottom: 1px solid #e0e0e0;
    position: relative;

    .back-icon {
      margin-right: 16px;
      cursor: pointer;
    }

    .title {
      font-weight: bold;
      color: #333333;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .people-list {
    max-height: 175px; /* Approx 3 items */
    overflow-y: auto;
  }
`;

const StyledPersonItem = styled.div.attrs({ className: "PersonItem" })`
  display: flex;
  align-items: center;
  padding: 8px 16px 8px 4px;
  border-bottom: 1px solid #e0e0e0;

  .avatar {
    width: 35px;
    height: 35px;
  }

  .details {
    display: flex;
    flex-direction: column;
    padding-left: 8px;
  }

  .name {
    font-weight: bold;
    color: #333333;

  }

  .timestamp {
    font-size: 12px;
    color: #6c6c6c;
  }
`;

const ChatMenuPersonList: React.FC<ChatMenuPersonListProps> = ({ onBack, title, people }) => (
  <StyledChatMenuPersonList>
    <div className="top-bar">
      <div className="back-icon" onClick={onBack}>
        <BackArrowIcon onClick={onBack} />
      </div>
      <div className="title">{title}</div>
    </div>
    <div className="people-list">
      {people.map((person, index) => (
        <StyledPersonItem key={index}>
          <div className="avatar">
            <BlankAvatar role={person.role}/>
          </div>
          <div className="details">
            <div className="name">{person.name}</div>
            <div className="timestamp">{person.timestamp}</div>
          </div>
        </StyledPersonItem>
      ))}
    </div>
  </StyledChatMenuPersonList>
);

export default ChatMenuPersonList;
